<div class="section-wrapper">
  <div class="section-description">
    <ng-content select="ls-cr-description"></ng-content>
  </div>

  <div class="section-content">
    <ng-content></ng-content>
  </div>
</div>

<ls-cr-divider></ls-cr-divider>
